var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ScrollBox',{ref:"scroll",staticStyle:{"min-height":"120px"},on:{"mouseover":function($event){_vm.isMouseIn = true},"mouseout":function($event){_vm.isMouseIn = false}}},[_vm._t("default"),_c('div',{staticClass:"fill",style:({ height: `${_vm.height}px` })})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }